import { Box, TableCell, TableRow, Button } from '@mui/material';
import { AuditStateQuestion } from '@safeguardproperties/corescript-react-npm/dist/types';
import { useMemo, useState } from 'react';
import { useAppSelector } from '../../redux/Store';
const THUMBNAIL_SIZE = 198;

// Add this import
import { styled } from '@mui/material/styles';

// Styled image component
const Thumbnail = styled('img')({
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  objectFit: 'cover',
  borderRadius: 4,
  border: '1px solid #ccc',
});

import IconImages from '../../assets/icons/IconImages';
import AiReasoningText, { getLuggageQuestions } from './AiReasoningText';

type AiInfoProps = {
  expanded: boolean;
  question: AuditStateQuestion;
};
import ImageDialog from '../Gallery/ImageDialog';
const AiInformation = ({ expanded, question }: AiInfoProps) => {
  const uploadedImageDetails = useAppSelector(
    (state) => state.gallery.uploadedImageDetails
  ); //
  const luggage = useAppSelector((state) => state.inspactOrder.luggage);

  const [visible, setVisible] = useState<boolean>(false);
  const [expandedPhotos, setExpanded] = useState<boolean>(expanded);

  const luggageQuestions = useMemo(
    () => getLuggageQuestions(luggage),
    [luggage]
  );

  const imagesAiOnly = useMemo(() => {
    if (question.AiAudit?.Images) {
      //Key is the image id
      return Object.entries(question.AiAudit.Images).map(([key, url]) => ({
        key: key,
        url: url,
      }));
    }
    return [];
  }, [question]);

  const matchedMetadataImages = useMemo(() => {
    if (!imagesAiOnly || !uploadedImageDetails) return [];
    const aiKeys = new Set(imagesAiOnly.map((img) => img.key));
    const foundImages = uploadedImageDetails.filter((img) =>
      aiKeys.has(img.id)
    );
    return foundImages;
  }, [imagesAiOnly, uploadedImageDetails]);

  return (
    <>
      <TableRow sx={{}}>
        <TableCell colSpan={7} sx={{ border: 'none', padding: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
            {imagesAiOnly && imagesAiOnly.length > 0 && (
              <Button
                onClick={(event) => {
                  event.stopPropagation();
                  setExpanded(!expandedPhotos);
                }}
                sx={{
                  minWidth: 0,
                  padding: '4px',
                  '&.Mui-disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'all !important',
                  },
                }}
              >
                <IconImages />
              </Button>
            )}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <AiReasoningText
                questionsByKey={luggageQuestions}
                questionTitle={question?.Title}
                reasoning={question?.AiAudit?.Reasoning}
              />
            </Box>
          </Box>
          {/* Display AI Audit Images */}
          <div
            onDoubleClick={() => {
              setVisible(true);
            }}
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
            }}
          >
            {expandedPhotos &&
              imagesAiOnly &&
              imagesAiOnly.map(({ key, url }) => (
                <Thumbnail
                  key={key}
                  src={String(url)}
                  alt={`AI Audit ${key}`}
                  aria-label={`Open AI Audit image ${key}`}
                />
              ))}
          </div>
        </TableCell>
      </TableRow>

      <ImageDialog
        images={matchedMetadataImages}
        open={visible}
        type='aiMedia'
        onClose={() => setVisible(false)}
      />
    </>
  );
};

export default AiInformation;
